export default "__VITE_ASSET__IuN2fy$Z__"